import { useState, useCallback } from "react";

export const useToolConfiguration = () => {
  const [showConfigurationSlideout, setShowConfigurationSlideout] = useState(false);
  const [selectedToolForConfiguration, setSelectedToolForConfiguration] = useState(null);
  const [isFromToolsLibrary, setIsFromToolsLibrary] = useState(false);

  const openConfiguration = useCallback((tool, fromToolsLibrary = false) => {
    setSelectedToolForConfiguration(tool);
    setIsFromToolsLibrary(fromToolsLibrary);
    setShowConfigurationSlideout(true);
  }, []);

  const closeConfiguration = useCallback(() => {
    setShowConfigurationSlideout(false);
    setSelectedToolForConfiguration(null);
    setIsFromToolsLibrary(false);
  }, []);

  const goBackToToolsLibrary = useCallback(() => {
    setShowConfigurationSlideout(false);
    setSelectedToolForConfiguration(null);
    setIsFromToolsLibrary(false);
  }, []);

  const saveConfiguration = useCallback((configurationData) => {
    console.log("Saving configuration:", configurationData);
    return Promise.resolve(configurationData);
  }, []);

  return {
    showConfigurationSlideout,
    selectedToolForConfiguration,
    isFromToolsLibrary,
    openConfiguration,
    closeConfiguration,
    goBackToToolsLibrary,
    saveConfiguration,
  };
};
